import { useGetCourseLibraryBanner } from "@/app2/shared/data";

/**
 * Feature hook for course library banner.
 * Delegates to data layer - no transformation needed.
 */
export const useCourseLibraryBanner = useGetCourseLibraryBanner;
